
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"videosiderTop\" id=\"js_siderTop\">\n    <div class=\"videosiderTopBg\"></div>\n    <div class=\"videosiderTopContent\" id=\"js_siderTop_control\">\n        <div class=\"siderTopTitle\" id=\"js_siderTop_title\"></div>\n        <div class=\"siderTopScale\" id=\"js_siderTop_scale\">\n            <ul class=\"js_siderScale_trigger\">\n                <li data-tag=\"half\">50%</li>\n                <li class=\"current\" data-tag=\"all\">100%</li>\n                <li data-tag=\"full\">满屏</li>\n            </ul>\n        </div>\n        <div class=\"siderTopControl\">\n            <ul class=\"js_siderControl_trigger\">\n                <li class=\"btn1\" data-tag=\"menu\" id=\"js_siderTop_menu\"><span>换节目</span></li>\n                <li class=\"btn2\" data-tag=\"down\" id=\"js_siderTop_down\"><span>下载</span></li>\n                <li class=\"btn3\" data-tag=\"share\" id=\"js_siderTop_share\"><span>分享</span></li>\n                <li class=\"btn6\" data-tag=\"switch\" id=\"js_siderTop_switch\">\n                    <a class=\"v_switch v_switchon\" href=\"javascript:;\">\n                        <span><em>弹幕</em></span>\n                    </a>\n                </li>\n                <li class=\"btn5\" id=\"js_siderTop_time\"></li>\n            </ul>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./components/f.component.video.pc/app/modules/title/main.ejs
// module id = i4xY
// module chunks = 0